<template>
  <div class="about">
    <nav class="navbar navbar-expand-lg navbar-light bg-light border-bottom shadow-sm mb-3">
      <div class="container">
        <router-link class="navbar-brand" to="/">
          <svg width="1.5em" height="1.5em" viewBox="0 0 16 16" class="back-icon bi bi-arrow-left-short" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"/>
          </svg>
          <span>{{$t('general.about')}}</span>
        </router-link>
      </div>
    </nav>
    <div class="container">
      <section class="py-5 text-center container">
        <div class="row py-lg-5">
          <div class="col-lg-6 col-md-8 mx-auto">
            <h1 class="font-weight-light">Playmatch</h1>
            <p class="lead text-muted">
              {{$t('about.whatIsPlaymatch')}}
            </p>
            <p>
              <router-link to="/" class="btn btn-primary my-2">{{$t('about.getStarted')}}</router-link>
            </p>
          </div>
        </div>
      </section>
      <h2 class="mt-4">{{$t('about.howDoesItWork')}}</h2>
      <p>
        {{$t('about.howDoesItWorkPart1')}}
      </p>  
      <p>
        {{$t('about.howDoesItWorkPart2')}}
      </p>

      <h2 class="mt-4">{{$t('about.installHeader')}}</h2>
      <p>
        {{$t('about.installDescription')}}           
      </p>
      <p>
        <b>Android:</b> {{$t('about.installAndroidPart1')}} 
        <svg width="0.9em" height="0.9em" viewBox="0 0 16 16" class="bi bi-three-dots-vertical" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
        </svg>
        {{$t('about.installAndroidPart2')}}
      </p>
      <p>
        <b>iPhone:</b> {{$t('about.installIphonePart1')}} 
        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-box-arrow-up" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M3.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2A1.5 1.5 0 0 1 14 6.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-8A1.5 1.5 0 0 1 3.5 5h2a.5.5 0 0 1 0 1h-2z"/>
          <path fill-rule="evenodd" d="M7.646.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 1.707V10.5a.5.5 0 0 1-1 0V1.707L5.354 3.854a.5.5 0 1 1-.708-.708l3-3z"/>
        </svg>
        {{$t('about.installIphonePart2')}}
      </p>

      <h2 class="mt-4">{{$t('about.dataStorageHeader')}}</h2>
      <p>
        {{$t('about.dataStorageText')}}        
      </p>

      <h2 class="mt-4">{{$t('about.spondHeader')}}</h2>
      <p v-html="$t('about.spondText1')"></p>
      <p v-html="$t('about.spondText2')"></p>

      <h2 class="mt-4">{{$t('about.contactHeader')}}</h2>
      <p v-html="$t('about.contactText')"></p>
      <h2 class="mt-4">{{$t('about.licenseHeader')}}</h2>
      <p>
        {{$t('about.licenseText')}}
      </p>

      <h2 class="mt-4">{{$t('about.thirdPartyLicenseHeader')}}</h2>
      <p>{{$t('about.thirdPartyLicenseText')}}</p>
      <ul>
        <li>
          <a href="https://github.com/vuejs/vuejs.org/blob/master/LICENSE" target="_blank">Vue JS 3</a>
        </li>
        <li>
          <a href="https://github.com/kazupon/vue-i18n/blob/v8.x/LICENSE" target="_blank">Vue i18n</a>
        </li>
        <li>
          <a href="https://getbootstrap.com/docs/4.0/about/license/" target="_blank">Bootstrap 5</a>
        </li>
        <li>
          <a href="https://fontawesome.com/license/free" target="_blank">Font Awesome</a>
          </li>
        <li>
          <a
            href="https://github.com/jakearchibald/idb-keyval/blob/master/LICENCE"  target="_blank">IDB KeyVal</a>
        </li>
        <li>
          <a href="https://render.com/" target="_blank">Renderer.com</a>
        </li>
      </ul> 

      <p class="mt-4" v-html="$t('about.restackText')">
      </p>    

      <div class="mt-5 mb-5 md-auto d-flex justify-content-center">
        <a href="https://restack.no" target="_blank" style="width: 200px"><img src="/restack_logo_full.svg" alt="Restack logo" /></a>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Vue } from "vue-class-component";

export default class About extends Vue {

  async clearCache() {    
    const cacheKeys = await caches.keys();
    console.log('Cache keys found: ', cacheKeys);
    for(const cacheKey in cacheKeys) {
      console.log('Delete cache ' + cacheKey);
      const didDelete = await caches.delete(cacheKey);
      if (didDelete) {
        console.log('Failed to delete');
      } else {
        console.log('Cache key deleted');
      }
    }
    
    setTimeout(() => {
      window.location.reload(true);
    }, 1000);
  }
}
</script>
